import React from 'react';
import { Preloader } from 'react-materialize';
import Loader from 'react-loader-spinner';
import './index.scss';

export const ContainedLoader = () => (
  <div className="contained-loader">
    <Preloader className="loader-spinner" />
  </div>
);

export const OverlaiedLoader = () => (
  <div className="overlaid-loader">
    <Preloader className="loader-spinner" />
  </div>
);

export const OverlaiedLoaderMsg = () => (
  <div className="overlaid-loader overlaid-loader-faturar-gto">
    <div className="spinner-faturar-gto">
      <Preloader className="loader-spinner" />
    </div>

    <div className="message-loader">
      <p>Aguarde enquanto enviamos a GTO para Faturamento.</p>
    </div>
  </div>
);

export const MiniLoader = () => (
  <Loader type="Ball-Triangle" color="#00BFFF" height="20" width="20" />
);
